import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const pct = (a, b) => (b ? `${Math.round((a / b) * 100)}%` : "—");

export function FreeFunnel() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/admin/free-funnel").then((r) => setF(r.data)); }, []);
  if (!f) return null;
  const steps = [["Free accounts", f.free_accounts, null], ["Read the free idea", f.read_free_idea, f.free_accounts], ["Saw unlock popup", f.saw_popup, f.read_free_idea], ["Clicked Unlock in popup", f.clicked_popup, f.saw_popup], ["Sent payment proof", f.sent_proof, f.free_accounts, "of free accounts"], ["Paid (approved)", f.paid, f.free_accounts, "of free accounts"]];
  return (
    <div className="sb-card p-5" data-testid="free-funnel">
      <div className="sb-eyebrow mb-3">Free account funnel (all time)</div>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
        {steps.map(([l, v, base, lbl = "of previous step"]) => (
          <div key={l} data-testid={`free-funnel-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <div className="text-[11px] text-[#8C9BA5] font-semibold">{l}</div>
            <div className="font-display text-xl font-extrabold">{v}</div>
            {base !== null && <div className="text-[11px] text-[#179B80] font-semibold">{pct(v, base)} {lbl}</div>}
          </div>
        ))}
      </div>
      <p className="text-xs text-[#5C6B73] mt-3" data-testid="free-funnel-paid-after-popup"><b>{f.paid_after_popup}</b> paid after seeing the popup ({pct(f.paid_after_popup, f.saw_popup)} of users who saw it).</p>
    </div>
  );
}
